import { Loader2, LogOut, Menu, RefreshCw } from 'lucide-react';
import React from 'react';
import { useAppState } from '../../context/AppStateContext';
import { ui } from '../../styles/ui';

export const Header = ({ onOpenSidebar, onRefresh }) => {
  const { currentUser, loading, logout } = useAppState();

  return (
    <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 sticky top-0 z-40">
      <div className="flex items-center justify-between px-4 sm:px-6 py-2.5">
        <div className="flex items-center space-x-3">
          <button onClick={onOpenSidebar} className={`lg:hidden ${ui.iconBtn}`}>
            <Menu className="h-5 w-5" />
          </button>
          <div className="hidden sm:block">
            <div className="text-sm font-medium text-gray-900 dark:text-white">
              Welcome back, {currentUser?.firstName || currentUser?.role}
            </div>
            {currentUser?.company?.name && (
              <div className="text-xs text-gray-500 dark:text-gray-400">{currentUser.company.name}</div>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          {onRefresh && (
            <button onClick={onRefresh} className={ui.iconBtn} disabled={loading} title="Refresh">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <RefreshCw className="h-5 w-5" />}
            </button>
          )}
          <div className="flex items-center space-x-2.5 pl-2.5 pr-3 py-1.5 rounded-lg bg-gray-100 dark:bg-gray-800">
            <div className="w-7 h-7 bg-indigo-600 rounded-md flex items-center justify-center shrink-0">
              <span className="text-white font-semibold text-xs">{currentUser?.firstName?.[0]?.toUpperCase() || 'A'}</span>
            </div>
            <div className="hidden sm:block">
              <div className="text-sm font-medium text-gray-900 dark:text-white leading-tight">
                {currentUser?.firstName} {currentUser?.lastName}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400 leading-tight">{currentUser?.role}</div>
            </div>
          </div>
          <button onClick={logout} className={ui.iconBtn} title="Logout">
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
};
